/*
 * Fora da tela porque a rota lê a lista no `validateSearch`, que vai no chunk
 * de entrada. Importada do componente, ela levaria o mapa inteiro para toda
 * página.
 */
export const ABAS_DO_MAPA = [
  'ecomapa',
  'genograma',
  'linha',
  'pessoas',
  'temas',
  'perguntar',
] as const
export type AbaDoMapa = (typeof ABAS_DO_MAPA)[number]
